import React from 'react';

const SuccessModal = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div className={`modal ${show ? 'show' : ''}`}>
      <div className="modal-content">
        <div className="modal-header">
          <h3>Request Submitted!</h3>
          <button className="modal-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="modal-body">
          <div className="success-icon">
            <i className="fas fa-check-circle"></i>
          </div>
          <p>Thank you for your service request! I'll review your project details and get back to you within 24 hours.</p>
          <p>You'll receive a confirmation email shortly.</p>
        </div>
        <div className="modal-footer">
          <button className="modal-button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal; 